module.exports = __webpack_public_path__ + "img/task-manager-icon.5c4f0cb6.svg";